import { takeLatest, put } from 'redux-saga/effects';
import axios from 'axios';

import { HomeTypes, HomeActions } from './home.redux';

export function* dataRequest(data) {
  try {
    yield axios.post('/contact-form.php', {
      headers: { 'content-type': 'application/json' },
      message: data.data.message,
      formName: data.data.formName,
    });

    yield put(HomeActions.buyFormSuccess());
  } catch (e) {
    yield put(HomeActions.buyFormFailure());
  }
}

export default function* homeSaga() {
  yield takeLatest(HomeTypes.BUY_FORM_REQUEST, dataRequest);
}


// WEBPACK FOOTER //
// ./src/modules/home/home.saga.js